import { render, staticRenderFns } from "./msgCode.vue?vue&type=template&id=6ce5a766&scoped=true"
import script from "./msgCode.vue?vue&type=script&lang=js"
export * from "./msgCode.vue?vue&type=script&lang=js"
import style0 from "./msgCode.vue?vue&type=style&index=0&id=6ce5a766&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce5a766",
  null
  
)

export default component.exports